import BaiduMap from "vue-baidu-map";
import Vue from "vue";
Vue.use(BaiduMap, {
  ak: "M6Z0Obru4jwGswmc9jgXniyO",
});
